<template>
    <b-modal v-model="show" :title="'Бино этажлилик коэффициенти'" :no-close-on-esc="true"
             :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Қаватлилиги <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="dictionaryData.data.storeys"
                                :class="{invalid : $v.dictionaryData.data.storeys.$error}"
                                placeholder="Танланг...">
                            <option value=""></option>
                            <option :value="option.id" v-for="option in storeys" :key="option.id">{{option.label}}</option>
                        </select>
                        <div class="red" v-if="$v.dictionaryData.data.storeys.$error">Қаватлилиги</div>
                    </div>
                    <div class="form-group">
                        <label>Қавати <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="dictionaryData.data.floor"
                                :class="{invalid : $v.dictionaryData.data.floor.$error}"
                                placeholder="Танланг...">
                            <option value=""></option>
                            <option :value="option.id" v-for="option in floors" :key="option.id">{{option.label}}</option>
                        </select>
                        <div class="red" v-if="$v.dictionaryData.data.floor.$error">Қавати</div>
                    </div>
                    <div class="form-group">
                        <label>Қиймати ( % )</label><br/>
                        <input type="number" class="form-control" v-model="dictionaryData.data.coeficient" placeholder="Киритинг..." min="0"/>
                    </div>
                </div>
            </div>

        </div>

        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_STOREYS_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask';
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import {clone} from '@/shared/utils';
    import {required} from 'vuelidate/lib/validators';

    export default {
        name: "BuildingStoreysAddView",
        components: {
            'b-modal': bModal,
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                dictionaryData: {
                    dictionaryType: 'BUILDING_STOREYS',
                    data: {
                        storeys: null,
                        floor: null,
                        coeficient: 0
                    }
                },
                floors: [
                    {"id": "1", label: "1-қават"},
                    {"id": "2", label: "2-қават"},
                    {"id": "3", label: "3-қават"},
                    {"id": "4", label: "4-қават"},
                    {"id": "5", label: "5-қават"},
                    {"id": "6", label: "6-қават"},
                    {"id": "7", label: "7-қават"},
                    {"id": "8", label: "8-қават"},
                    {"id": "9", label: "9-қават"},
                    {"id": "10", label: "10-қават"},
                    {"id": "11", label: "11-қават"},
                    {"id": "12", label: "12-қават"},
                    {"id": "13", label: "13-қават"},
                    {"id": "14", label: "14-қават"},
                    {"id": "15", label: "15-қават"},
                    {"id": "16", label: "16-қават"},
                    {"id": "17", label: "17-қават"},
                    {"id": "18", label: "18-қават"},
                    {"id": "19", label: "19-қават"},
                    {"id": "20", label: "20-қават"},
                ],
                storeys: [
                    {"id": "1", label: "1 қаватли"},
                    {"id": "2", label: "2 қаватли"},
                    {"id": "3", label: "3 қаватли"},
                    {"id": "4", label: "4 қаватли"},
                    {"id": "5", label: "5 қаватли"},
                    {"id": "6", label: "6 қаватли"},
                    {"id": "7", label: "7 қаватли"},
                    {"id": "8", label: "8 қаватли"},
                    {"id": "9", label: "9 қаватли"},
                    {"id": "10", label: "10 қаватли"},
                    {"id": "11", label: "11 қаватли"},
                    {"id": "12", label: "12 қаватли"},
                    {"id": "13", label: "13 қаватли"},
                    {"id": "14", label: "14 қаватли"},
                    {"id": "15", label: "15 қаватли"},
                    {"id": "16", label: "16 қаватли"},
                    {"id": "17", label: "17 қаватли"},
                    {"id": "18", label: "18 қаватли"},
                    {"id": "19", label: "19 қаватли"},
                    {"id": "20", label: "20 қаватли"},
                ],
                wallTypes: []
            }
        },
        validations: {
            dictionaryData: {
                data: {
                    floor: {
                        required: required
                    },
                    storeys: {
                        required: required
                    }
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.dictionaryData.dictionaryType = 'BUILDING_STOREYS';
                this.$http.post('dictionary/save', this.dictionaryData)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('buildingStoreysChanged', response);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: response.message,
                                type: 'warning'
                            });
                        }
                    });
            },

        },
        created() {
            this.$eventBus.$on('showBuildingStoreysAdd', (data) => {
                if (data) {
                    this.dictionaryData.id = data.id;
                    this.dictionaryData.data = clone(data.data);
                } else {
                    this.dictionaryData = {
                        data: {
                            coeficient: 0
                        }
                    }
                }

                this.show = true;
            });
        }
    }
</script>
<style scoped>

</style>